// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
import pluralize from "pluralize";
// invite-card imports
import { IProps, IState } from "./invite-card.d";
import * as styles from "./invite-card.styles";
// actions
// other internals
import { UserImage } from "@components/user-image";
import { A } from "@ui";
import { LogoClock } from "@components/logo";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
// material-ui
import { InviteButton } from "@components/invite-button";
import { InfoTip } from "@components/tool-tip";

//////////////////
// COMPONENT
//////////////////
export class InviteCardComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private renderInviteeInfo() {
    let info = "";
    const invitee = this.props.invitee;
    if (invitee.inviteReason == ISchema.SuggestedOrgInviteReason.MeetsWithYourTeammates) {
      info = invitee.givenName + " meets with your teammates";
    } else if (invitee.inviteReason == ISchema.SuggestedOrgInviteReason.OnYourTeam) {
      info = invitee.givenName + " is on your team";
    } else if (invitee.numberOfOrganizedMeetings) {
      info =
        invitee.givenName + " organizes " + invitee.numberOfOrganizedMeetings + " of your meetings";
      if (invitee.numberOfSharedMeetings) {
        const meetings = pluralize("meeting", invitee.numberOfSharedMeetings);
        info += " and you share " + invitee.numberOfSharedMeetings + " other " + meetings;
      }
    } else if (invitee.numberOfSharedMeetings) {
      const meetings = pluralize("meeting", invitee.numberOfSharedMeetings);
      info =
        "You share " +
        invitee.numberOfSharedMeetings +
        " " +
        meetings +
        " with " +
        invitee.givenName;
    } else {
      info = "You share meetings with " + invitee.givenName;
    }
    return <span style={styles.tooltipContent}>{info}</span>;
  }

  private maybeRenderUserBadge = (isUser?: boolean, size?: number) => {
    if (!isUser) {
      return <span />;
    }

    const badgeStyle = {
      ...styles.badge,
      width: size && size > 50 ? 22 : 18,
      height: size && size > 50 ? 22 : 18,
      right: size && size > 60 ? 0 : -3,
      bottom: size && size > 60 ? 0 : -3,
    };
    const logoSize = badgeStyle.width - 4;

    return (
      <div style={badgeStyle}>
        <LogoClock size={logoSize} fill={greys.white} />
      </div>
    );
  };

  public render() {
    const tipTarget = <A style={styles.suggested}>suggested</A>;

    return (
      <div>
        <div style={styles.item}>
          <div style={{ ...styles.row, justifyContent: "space-between" }}>
            <div style={styles.row}>
              <div style={styles.avatar}>
                <UserImage
                  imgUrl={this.props.invitee.externalImageUrl}
                  name={this.props.invitee.givenName}
                  style={{ width: 34, height: 34 }}
                />
                {this.maybeRenderUserBadge(this.props.invitee.isUser, 34)}
              </div>
              <div style={{ marginLeft: 10 }}>
                <div
                  style={styles.name}
                >{`${this.props.invitee.givenName} ${this.props.invitee.familyName}`}</div>
                <div style={styles.email}>{this.props.invitee.targetCalendarId}</div>
              </div>
            </div>

            <div className="cw-flex cw-flex-row cw-items-center cw-gap-2">
              {this.props.invitee.isSuggested &&
                !this.props.invitee.isUser &&
                !this.props.invitee.isPending && (
                  <InfoTip
                    text={this.renderInviteeInfo()}
                    targetElement={tipTarget}
                    tipType={"info"}
                  />
                )}
              <InviteButton
                org={this.props.org}
                invitee={this.props.invitee}
                inviteCallback={this.props.inviteCallback}
                recentlySent={this.props.recentlySent}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

//////////////////
// RELAY
//////////////////
import { fragments } from "./InviteCard.gql";
export const InviteCard = createFragmentContainer(InviteCardComponent, fragments);
